export default {
  // 鉴权信息
  AUTH: 'authorization',
  // 账户信息
  ACCOUNT_INFO: 'identity_account_info',
  // 账户菜单
  ACCOUNT_MENU: 'identity_account_menu',
  //用户信息
  CURRENT_USER_INFO: 'current_user_info'
}
